
// TODO: conventions for error codes.

export const ERR_INTERNET_DISCONNECTED = "ERR_INTERNET_DISCONNECTED";